import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { CustomDialog, StyledDataGrid } from '../../../components/StyledComponents'
import { DialogActions, DialogContent, DialogTitle, Box, Checkbox, Stepper, Step, StepLabel } from '@mui/material'
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, ControlpanelSuccess3thButton, GrayIconButton } from '../../../components/StyledButton'
import CloseIcon from '@mui/icons-material/Close';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useTranslation } from 'react-i18next';
import CustomCropImage from '../CustomCropImage/CustomCropImage';
import SearchIcon from '@mui/icons-material/Search';
import CustomInput from '../../../components/CustomInput';
import my_company_logo from "../../../assets/images/logo/my-company-logo.png"
import SaveIcon from '@mui/icons-material/Save';
import { useLoading } from '../../../context/LoadingContext';
import { toast } from 'react-toastify';
import { updateUserToGroup } from '../../../axios/Group/GroupUrlApi';
import DefaultTooltip from '../../../components/DefaultTooltip';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import ArrowRepeatIcon16pxSvg from '../../../assets/images/icons/ArrowRepeatIcon16pxSvg';
import SaveIcon14pxSvg from '../../../assets/images/icons/SaveIcon14pxSvg';
import CustomPagination from '../CustomPagination';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';
import { getUserList } from '../../../axios/User/UserApi';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';
import CustomGridToolbarQuickFilterNew2 from '../CustomGridToolbarQuickFilterNew2';
import { generateTranslateMuiTable } from '../../../utils/Function/commonFunction';
import ServerSearchInput from '../../../components/ServerSearchInput';

const AddUserToGroupWhenCreateGroupDialog = ({ activeStep, steps, onClose, handleRefreshTable, info, groupId, getStatusAddNewGroup }) => {
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language;
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [show, hide] = useLoading();
  const [userData, setUserData] = useState([]);
  const [gridLoading, setGridLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0)
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [rowData, setRowData] = useState([]);
  const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const handleSearchChange = (value) => {
    setSearchText(value);
  };
  const encodedSearchText = useMemo(() => {
    return searchText;
  }, [searchText]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(encodedSearchText);
      setPage(0);
    }, 700);

    return () => clearTimeout(handler);
  }, [encodedSearchText]);

  const [adminStatusMap, setAdminStatusMap] = useState({});

  const handleCloseDialog = () => {
    onClose()
  }
  useEffect(() => {
    const fetchData = async () => {
      setGridLoading(true);
      try {
        const payload = {
          statusId: 1,
          page: page + 1,
          pageSize: pageSize,
          status: null,
          langId: localStorage.getItem("i18nextLngId"),
          searchText: debouncedSearchText || null,
        }
        const response = await getUserList(payload);
        // const { data, headers } = await getUserList(page + 1, pageSize);
        setRowCount(response.data.pagination.totalElements)
        // const { data, headers } = await getUserList(page + 1, pageSize);
        // setRowCount(parseInt(headers['total_records']));
        const employees = response.data.data.map(e => ({
          ...e,
          isAdmin: adminStatusMap[e.userId] ?? false,
        }));
        setRowData(employees);
      } catch (error) {
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data));
          }
        } else {
          toast.error(t('common.network-timeout'));
        }
      } finally {
        setGridLoading(false);
      }
    };

    fetchData();
  }, [page, pageSize, adminStatusMap, debouncedSearchText]);





  const columnData = [
    // {
    //   field: 'isSelected', headerName: t('common.content-077'), minWidth: 60, flex: 1,
    //   renderCell: (params) => (
    //     <Checkbox
    //       checked={params.row.isAdmin}
    //       onChange={(event) => {
    //         handleCheckboxChange(params.row.userId, "isAdmin", event.target.checked);
    //       }}
    //     />
    //   ),
    // },
    {
      field: 'isSelected',
      headerName: t('common.content-077'),
      minWidth: 60,
      flex: 1,
      renderHeader: () => (
        <Checkbox
          checked={allChecked}
          indeterminate={!allChecked && someChecked}
          onChange={(event) => handleSelectAllCheckbox(event.target.checked)}
        />
      ),
      renderCell: (params) => (
        <Checkbox
          checked={params.row.isAdmin}
          onChange={(event) => {
            handleCheckboxChange(params.row.userId, "isAdmin", event.target.checked);
          }}
        />
      ),
    },
    { field: 'employeeCode', headerName: t('common.employee-code'), minWidth: 70, flex: 1 },
    {
      field: 'fullName', headerName: t('common.full-name'), minWidth: 250, flex: 1
    },
    { field: 'email', headerName: 'Email', minWidth: 200, flex: 1 },

  ];


  const allChecked = useMemo(() => {
    return rowData.length > 0 && rowData.every(row => row.isAdmin);
  }, [rowData]);

  const someChecked = useMemo(() => {
    return rowData.some(row => row.isAdmin);
  }, [rowData]);




  const handleCheckboxChange = (userId, columnName, isChecked) => {
    const updatedRows = rowData.map(row => {
      if (row.userId === userId) {
        return { ...row, [columnName]: isChecked };
      }
      return row;
    });

    const updatedSelectedIds = isChecked
      ? [...selectedUserIds, userId]
      : selectedUserIds.filter(id => id !== userId);

    setRowData(updatedRows);
    setSelectedUserIds(updatedSelectedIds);
    setAdminStatusMap(prev => ({ ...prev, [userId]: isChecked }));
  };


  const handleSelectAllCheckbox = (isChecked) => {
    const updatedStatus = { ...adminStatusMap };
    const updatedSelectedIds = [...selectedUserIds];

    rowData.forEach(row => {
      updatedStatus[row.userId] = isChecked;
      if (isChecked && !updatedSelectedIds.includes(row.userId)) {
        updatedSelectedIds.push(row.userId);
      } else if (!isChecked) {
        const index = updatedSelectedIds.indexOf(row.userId);
        if (index !== -1) updatedSelectedIds.splice(index, 1);
      }
    });

    setAdminStatusMap(updatedStatus);
    setSelectedUserIds(updatedSelectedIds);
    const updatedRows = rowData.map(row => ({
      ...row,
      isAdmin: isChecked,
    }));
    setRowData(updatedRows);
  };





  const handleSubmit = async (e) => {
    const payload = {
      group: groupId,
      listUser: selectedUserIds.join(","),
      langId: localStorage.getItem("i18nextLngId")
    }

    try {
      e.preventDefault();
      show();
      const response = await updateUserToGroup(payload);

      toast.success(t('common.add-user-to-group-successfully'));
      getStatusAddNewGroup(true)

      handleRefreshTable();
      handleCloseDialog();
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }

    } finally {
      hide();
    }
  };

  const handleQuickFilterChange = (searchText) => {
    const lowerSearch = searchText.toLowerCase();
    const filtered = rowData.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(lowerSearch)
      )
    );
    setUserData(filtered);
  };

  const templateToolbar = useCallback(
    () => (
      <div className="flex gap-2 justify-end mb-2">
        <ServerSearchInput fullWidth onChange={handleSearchChange} />
      </div>
    ),
    [t]
  );

  return (
    <CustomDialog
      maxWidth={"xl"}
      open
      onClose={handleCloseDialog}
      keepMounted
      transitionDuration={window.__tourIsOpen ? 0 : undefined}
      data-tour="user-group-dialog-step2"
    >
      <DialogTitle>
        <div className='flex justify-between'>
          <div className='flex items-center gap-4'>
            <p className='text-xl font-semibold '>{t('common.add-group-users')}</p>
            <DefaultTooltip
              title={t('tool-tip.add-edit-user-group')}
              readMore={false}
              content={
                <div className='flex flex-col gap-3'>
                  <p>{t('tool-tip.this-view-allows-to-add-a-new-user-group')}.</p>
                </div>
              }>
              <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
            </DefaultTooltip>
          </div>
          <GrayIconButton onClick={handleCloseDialog}>
            <CloseIcon />
          </GrayIconButton>
        </div>
      </DialogTitle>
      <DialogContent style={{ paddingBottom: 'unset' }}>

        <div className="mt-6 mb-6">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{
              "& .MuiStepLabel-label.Mui-active": {
                color: "#0057FF",
                fontWeight: 600,
              },
              "& .MuiStepLabel-label.Mui-completed": {
                color: "#0057FF",
                fontWeight: 600,
              },
              "& .MuiStepIcon-root.Mui-active": {
                color: "#0057FF",
              },
              "& .MuiStepIcon-root.Mui-completed": {
                color: "#0057FF",
              },
              "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line, & .MuiStepConnector-root.Mui-completed .MuiStepConnector-line":
              {
                borderColor: "#0057FF",
              },
            }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>

        <div className='h-auto mt-[24px]' data-tour="user-group-dialog-step2-input">
          <StyledDataGrid
            sx={{
              height: '400px',
              width: '100%',
            }}
            rows={rowData}
            rowCount={rowCount}
            columns={columnData}
            getRowId={(r) => r.userId}
            loading={gridLoading}
            disableRowSelectionOnClick

            slots={{
              toolbar: templateToolbar,
              pagination: CustomPagination,
              noRowsOverlay: NoRowOverlay,
              columnsPanel: CustomColumnsPanel,
            }}
            slotProps={{
              pagination: {
                page,
                count: rowCount,
                rowsPerPage: pageSize,
                onPageChange: setPage,
                onRowsPerPageChange: setPageSize,
              },
            }}
            localeText={tableTranslated}

          />

        </div>
      </DialogContent>
      <DialogActions>
        <div className='flex gap-2 px-4 py-4'>
          <div data-tour="user-group-dialog-step2-dolater">
            <ControlpanelSuccess3thButton onClick={handleCloseDialog}>
              <p>{t('button.do-later')}</p>
            </ControlpanelSuccess3thButton>
          </div>
          <div data-tour="user-group-dialog-step2-confirm">
            <ControlpanelPrimaryButton onClick={handleSubmit}>
              <p>{t('button.confirm')}</p>
            </ControlpanelPrimaryButton>
          </div>
        </div>
      </DialogActions>
    </CustomDialog>
  )
}

export default AddUserToGroupWhenCreateGroupDialog